import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/providers/session.service';
import { Router } from '@angular/router';
import { ROUTES} from '../../core/sidebar/sidebar.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToasterService } from '@app-providers/toaster.service';
import { FormHelperService } from '@app-providers/form-helper.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Role } from '@app-models/role.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public form: FormGroup;
  public isSubmitting: boolean;
  logoPath: any;
  home: string = '/dashboard';

  constructor(
    private _toasterService: ToasterService,
    private _sessionService: SessionService,
    private _formHelperService: FormHelperService,
    private sanitizer: DomSanitizer,
    private _router: Router,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.form = this._fb.group({
      identifier: [null, Validators.required],
      password: [null, Validators.required],
    });
    const card = document.getElementsByClassName('card')[0];
    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      card.classList.remove('card-hidden');
    }, 500);
    this.load();
  }

  /**
   * [Description] Load data
   */
  async load() {
    try {
      // Get session Status
      const status = await this._sessionService.getSessionStatus().toPromise();
      if (status) {
        this.redirect();
        return;
      }
    } catch (e) { }
  }
  redirect() {
    let menuItems = [];
    const droit = this._sessionService.user.droit;
    if ((this._sessionService.user.role as Role).type === 'exploitant') {
     menuItems = ROUTES;
    } else {
      if (!droit) {
       menuItems = [];
      } else {
        const droitArray = Object.entries(droit).filter(i => i[1]).map(i => i[0]);
        menuItems = ROUTES.filter(route => {
          if (Array.isArray(route.autorisation)) {
            return droitArray.some(i => route.autorisation.indexOf(i) > -1);
          } else {
            return droitArray.indexOf(route.autorisation) > -1;
          }
        }).map(route => {
          if (route.collapse) {
            route.children = route.children.filter( r => {
              if (Array.isArray(r.autorisation)) {
              return droitArray.some(i => r.autorisation.indexOf(i) > -1);
            } else {
              return droitArray.indexOf(r.autorisation) > -1;
            }
            });
            return route;
          } else {
            return route;
          }
        });
        this.home = menuItems[0].path;
      }
      this._router.navigate([this.home]);
    }
  }


  /**
   *
   *
   * @returns
   * @memberof LoginComponent
   */
  submit() {
    this.isSubmitting = true;
    if (this.form.valid) {
      this._sessionService.logout();
      this._sessionService.login(this.form.value).subscribe(_ => {
        this._router.navigate(['/dashboard']);
        this._formHelperService.validateAllFormFields(this.form);
        this.isSubmitting = false;
      }, err => {
        this._toasterService.error('Identifiants incorrects');
        this._formHelperService.validateAllFormFields(this.form);
        this.isSubmitting = false;
      });
    } else {
      this._formHelperService.validateAllFormFields(this.form);
      this.isSubmitting = false;
    }
  }

  /**
   * [Description] Set error class on form based on Form and field validation
   * @param {FormGroup} form
   * @param {string} field
   */
  displayFieldCss(form: FormGroup, field: string) {
    return {
      'has-error': this._formHelperService.isFieldValid(form, field),
      'has-feedback': this._formHelperService.isFieldValid(form, field)
    };
  }

}

